/**
 * Recebe como um argumento um valor e transforma através do replace
 * em máscara de CPF. Retorna uma string formatada.
 * @param {string} cpf Valor para colocar a máscara de CPF.
 */
export function formatToCPF(cpf) {
  if (cpf === null) {
    return;
  }

  const pattern = /^(\d{3})(\d{3})(\d{3})(\d{2})/;
  const replacer = '$1.$2.$3-$4';
  return cpf.replace(pattern, replacer);
}
